import request from "@/api/request"

function index(){
    return request({
        method:'get', //请求方式
        url:'/gamehome/gameicon/' //路径,

    })
}
function get_user_list(params){

    return request({
        method:'post', //请求方式
        url:'/gamehome/querylist/', //路径,
        params:params
    })
}
function get_user_list_next(url){
    return request({
        method:'post', //请求方式
        url:url, //路径,
    })
}
// export default a import b form 名称随便起
// export {
//     a          import {a} 名称一一对应
// }

export {
    index,
    get_user_list,
    get_user_list_next
}